export default __webpack_public_path__ + "static/media/background.d089ea1c.png";